module.exports = __webpack_public_path__ + "38e7a1fdedeecb5edb5ff83f7fe27507.png";